import React from 'react'
import styled from 'styled-components'
import AuthPanel from '../Auth/AuthPanel'
import Images from '../ImageList/List'
import Status from '../../container/StatusContainer'
import CompanyProfiles from '../CompanyProfileOverview'
import Button from '../Button'

const ButtonWithMargin = styled(Button)`
  margin-right: 1rem;
`

const views = { status: Status, bilder: Images, unternehmen: CompanyProfiles }

class Admin extends React.Component {
  state = {
    view: 'unternehmen',
  }

  switchView(view) {
    this.setState({ view })
  }

  render() {
    const { auth } = this.props
    const { view } = this.state
    const nav = (
      <React.Fragment>
        {Object.keys(views).map(v => (
          <ButtonWithMargin
            key={`button-${v}`}
            text={v.toUpperCase()}
            size="small"
            toggle={view === v ? true : false}
            onClick={() => this.switchView(v)}
          />
        ))}
      </React.Fragment>
    )
    return (
      <div>
        <AuthPanel auth={auth} children={nav} />
        {auth && auth.isAuthenticated() && React.createElement(views[view])}
      </div>
    )
  }
}

export default Admin
